import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type DeviceLinkOnAssetTransfer_AudioAsset_Fragment = { __typename?: 'AudioAsset', deviceLink?: { __typename?: 'DeviceLink', id?: string | null } | null };

export type DeviceLinkOnAssetTransfer_DocumentAsset_Fragment = { __typename?: 'DocumentAsset', deviceLink?: { __typename?: 'DeviceLink', id?: string | null } | null };

export type DeviceLinkOnAssetTransfer_FileAsset_Fragment = { __typename?: 'FileAsset' };

export type DeviceLinkOnAssetTransfer_FolderAsset_Fragment = { __typename?: 'FolderAsset' };

export type DeviceLinkOnAssetTransfer_ImageAsset_Fragment = { __typename?: 'ImageAsset', deviceLink?: { __typename?: 'DeviceLink', id?: string | null } | null };

export type DeviceLinkOnAssetTransfer_InteractiveAsset_Fragment = { __typename?: 'InteractiveAsset' };

export type DeviceLinkOnAssetTransfer_InteractiveLiveAsset_Fragment = { __typename?: 'InteractiveLiveAsset' };

export type DeviceLinkOnAssetTransfer_ModelAsset_Fragment = { __typename?: 'ModelAsset', deviceLink?: { __typename?: 'DeviceLink', id?: string | null } | null };

export type DeviceLinkOnAssetTransfer_UnsupportedAsset_Fragment = { __typename?: 'UnsupportedAsset', deviceLink?: { __typename?: 'DeviceLink', id?: string | null } | null };

export type DeviceLinkOnAssetTransfer_VersionStackAsset_Fragment = { __typename?: 'VersionStackAsset' };

export type DeviceLinkOnAssetTransfer_VideoAsset_Fragment = { __typename?: 'VideoAsset', deviceLink?: { __typename?: 'DeviceLink', id?: string | null } | null };

export type DeviceLinkOnAssetTransferFragment = DeviceLinkOnAssetTransfer_AudioAsset_Fragment | DeviceLinkOnAssetTransfer_DocumentAsset_Fragment | DeviceLinkOnAssetTransfer_FileAsset_Fragment | DeviceLinkOnAssetTransfer_FolderAsset_Fragment | DeviceLinkOnAssetTransfer_ImageAsset_Fragment | DeviceLinkOnAssetTransfer_InteractiveAsset_Fragment | DeviceLinkOnAssetTransfer_InteractiveLiveAsset_Fragment | DeviceLinkOnAssetTransfer_ModelAsset_Fragment | DeviceLinkOnAssetTransfer_UnsupportedAsset_Fragment | DeviceLinkOnAssetTransfer_VersionStackAsset_Fragment | DeviceLinkOnAssetTransfer_VideoAsset_Fragment;

export const DeviceLinkOnAssetTransfer = /*#__PURE__*/ gql`
    fragment DeviceLinkOnAssetTransfer on Asset {
  ... on AudioAsset {
    deviceLink {
      id
    }
  }
  ... on DocumentAsset {
    deviceLink {
      id
    }
  }
  ... on ImageAsset {
    deviceLink {
      id
    }
  }
  ... on VideoAsset {
    deviceLink {
      id
    }
  }
  ... on ModelAsset {
    deviceLink {
      id
    }
  }
  ... on UnsupportedAsset {
    deviceLink {
      id
    }
  }
}
    ` as unknown as DocumentNode<DeviceLinkOnAssetTransferFragment, unknown>;

        

        
export const useDeviceLinkOnAssetTransferFragment = (
  input: string | Omit<UseFragmentOptions<DeviceLinkOnAssetTransferFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Asset' } };
    return input;
  })();

  return useFragment<DeviceLinkOnAssetTransferFragment>({
    fragment: DeviceLinkOnAssetTransfer,
    fragmentName: 'DeviceLinkOnAssetTransfer',
    ...options,
  });
};
  
        